export const DateTimeIntervals = [
  {
    minDateDiff: 0,
    tId: 'ALL_DATES',
  },
  {
    minDateDiff: 24 * 60 * 60 * 1000,
    tId: 'MORE_THAN_24_H',
  },
  {
    minDateDiff: 3 * 24 * 60 * 60 * 1000,
    tId: 'MORE_THAN_3_DAYS',
  },
  {
    minDateDiff: 7 * 24 * 60 * 60 * 1000,
    tId: 'MORE_THAN_A_WEEK',
  },
  {
    minDateDiff: 30 * 24 * 60 * 60 * 1000,
    tId: 'MORE_THAN_A_MONTH',
  },
];
